export default "__VITE_ASSET__DTc$zQj7__"